import Image from '@atoms/Image';
import React from 'react'

const MuhuratDaysBanner = () => {
  return (
    <div className='w-full relative z-50 max-w-[1090px] mx-auto'>
      <Image src='/images/muhurat-days-desktop.webp' className='w-full md:block hidden rounded-lg' alt='muhurat-banner' />
      <Image src='/images/muhurat-days-mobile.webp' className='w-full md:hidden rounded-lg' alt='muhurat-banner' />
    </div>
  )
}

export default MuhuratDaysBanner;
